export const STORE_ERROR = '[errors] STORE_ERROR';
export const DELETE_ERROR = '[errors] DELETE_ERROR';
